var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('iframe',{staticClass:"w-full h-screen",attrs:{"src":_vm.iframeUrl,"title":"Card Monitoring","frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }